import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Validator from '../../../../Common/validator';
import NewSuggestSelectInput from '../../../../Common/newSuggestSelectInput';
import { isStringValid } from '../../../../Util/stringValidator';

class CreateClientForm extends Component{
  constructor(props) {
    super(props);
    const { defaultValue } = this.props;
    this.state = {
      client: {
        id: defaultValue.id,
        name: defaultValue.name
      },
      contact: defaultValue.contact,
      clientTouched: (defaultValue.id!=null),
      contactTouched: (defaultValue.id!=null)
    }
  }
  onClientChange = (val) => {
    let contactVal = this.state.contact;
    if(!isStringValid(val.name) || (val.id==null && this.state.client.id!=null))
      contactVal = {name: "", id: null}
    if(val.id==null)
      contactVal.id = null

    this.setState({
      client: val,
      contact: contactVal
    })
  };
  onClientBlur = () => {
    this.setState({
      clientTouched: true
    })
  };
  onContactChange = (val) => {
    this.setState({
      contact: val
    })
  };
  onContactBlur = () => {
    this.setState({
      contactTouched: true
    })
  };
  isValid = () => {
    //set both fields to touched
    this.setState({
      clientTouched: true,
      contactTouched: true
    })
    return (isStringValid(this.state.client.name) && isStringValid(this.state.contact.name))
  };
  getValues = () => {
    return {
      ...this.state.client,
      contact: this.state.contact
    }
  };
  render()  {
    const { getClientSuggestions, clientSuggestions, contactSuggestions,
      getContactSuggestions
     } = this.props;
    const { client, contact, clientTouched, contactTouched } = this.state;
    return (
      /* CREATE NEW PROJECT */
      <div>
        <div className="row" style={styles.informationDetailsEdit}>
          <div className="col-xs-12">
            <div style={styles.inputLabel}>Firmanavn</div>
            <Validator
              isValid={(!clientTouched || (isStringValid(client.name)))}
              msg={"Skal udfyldes"}>
              <NewSuggestSelectInput
                placeholder="Firmanavn"
                onChange={this.onClientChange}
                onBlur={this.onClientBlur}
                suggestions={clientSuggestions}
                onQuery={getClientSuggestions}
                value={client}
                />
            </Validator>
          </div>
        </div>
        <div style={styles.inputLabel}>Kontaktperson</div>
        <Validator
          isValid={(!contactTouched || isStringValid(contact.name) || !isStringValid(this.state.client.name))}
          msg={"Skal udfyldes"}>
          <NewSuggestSelectInput
            placeholder="Kontaktperson"
            onChange={this.onContactChange}
            onBlur={this.onContactBlur}
            suggestions={contactSuggestions}
            onQuery={(val) => {
              if(client.id)
                getContactSuggestions(val, client.id)
            }}
            value={contact}
            isDisabled={!isStringValid(this.state.client.name)}
            />
        </Validator>
      </div>
    );
  }
}


var styles = {
  informationDetailsEdit: {
    paddingBottom: '10px'
  },
  createProjectContainer: {
    lineHeight: '35px',
    textAlign: 'right',
    paddingRight: '38px',
    position: 'relative',
    fontSize: '12px'
  },
  createProjectPlusIcon: {
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    fontSize: '20px',
    position: 'absolute',
    top: '8px',
    right: '12px'
  },
  inputLabel: {
    fontSize: '11px'
  }
}
  CreateClientForm.propTypes = {
    getClientSuggestions: PropTypes.func.isRequired,
    clientSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })),
    contactSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })),
    getContactSuggestions: PropTypes.func.isRequired,
    defaultValue: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      contact: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string.isRequired
      }).isRequired
    })
  };
export default Radium(CreateClientForm)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Helpers/createClientForm.jsx